/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiDropContextProfileContext {
    'rating': number;
    'min_rating': number;
    'max_rating': number;
    'reaction': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "rating",
            "baseName": "rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "min_rating",
            "baseName": "min_rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "max_rating",
            "baseName": "max_rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "reaction",
            "baseName": "reaction",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropContextProfileContext.attributeTypeMap;
    }

    public constructor() {
    }
}

